import { fetchPatientSuggestionsEndpoint } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { ClinicianSuggestionViewT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPatientSuggestions(
  patientUserId: string,
  signal?: AbortSignal
): Promise<ClinicianSuggestionViewT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPatientSuggestionsEndpoint(patientUserId, config);
  return response.data.suggestions;
}
